import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
    BoxTitle,
    BoxContainer,
    BoxHead,
    Underline,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import NotFoundModel from "../../Components/NotFoundModel";
import { useGenericGet } from "../../utilities/useGenericGet";
import { toast } from "react-toastify";
import SideModal from "../../Components/SideModal";
import ActivityLogsModal from "../../Components/ActivityLogs/ActivityLogsModal";
import MissedRentTable from "../../Components/Tenants/MissedRentTable";

const MissedRent = () => {
    const user = useSelector((state) => state.UserReducer.user);
    const [isFocused, setIsFocused] = useState(false);
    const [selectedData, setSelectedData] = useState("");
    const [apiData, setApiData] = useState();
    const [showLogs, setShowLogs] = useState(false);
    const [activityLogs, setActivityLogs] = useState([]);

    const fetchFunction = async () => {
        const response = await axios.get(
            `${Config.apiUrl}/client/list/tenants/missing/rent`,
            {
                headers: {
                    authorization: "Bearer" + " " + user.token,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.data === false) error = true;
        else {
            setApiData(res?.list);
            setIsFocused(true);
        }
    };

    const getError = () => { };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        const handler = setTimeout(() => {
            sessionStorage.removeItem("tenant_active_page");
            getListMutate();
        }, 100);

        return () => {
            clearTimeout(handler);
        };
    }, []);

    const { mutate: getActivityLogsMutate, isLoading: logsLoading } = useGenericGet(
        user.token,
        (res) => {
            setActivityLogs(res?.data || []);
            setShowLogs(true);
        },
        () => toast.error("Failed to load logs")
    );

    const openLogs = (item) => {
        getActivityLogsMutate({
            url: `${Config.apiUrl}/activity-log/tenant/list`,
            params: `&id=${item.tenantId}`
        });
    };

    return (
        <>
            <BoxContainer>
                <BoxHead>
                    <BoxTitle className="!mb-0 whitespace-nowrap">
                        {"Missed Rent"}
                        <Underline />
                    </BoxTitle>

                </BoxHead>
                <SideModal
                    isOpen={showLogs}
                    onClose={() => setShowLogs(false)}
                >
                    <ActivityLogsModal
                        isOpen={showLogs}
                        onClose={() => setShowLogs(false)}
                        logs={activityLogs}
                    />;
                </SideModal>

                {!error && !isLoading && apiData && (

                    <TableWrapper>
                        <MissedRentTable
                            apiData={error ? [] : apiData?.length > 0 ? apiData : []}
                            setSelectedData={setSelectedData}
                            selectedData={selectedData}
                            openLogs={openLogs}
                        />
                        {(error || apiData?.length == 0) && !isLoading && (
                            <NotFoundModel />
                        )}
                    </TableWrapper>

                )}

                {(isLoading || isRefetching) && <Loading />}

                {error && !isLoading && <NotFoundModel />}


            </BoxContainer>
        </>
    );
};

const TableWrapper = tw.h1`bg-white border my-8 rounded-md `;

export default MissedRent;
